<template>
    <div style=" width:100%; margin-left: 5%">
        <b-tabs content-class="mt-3" style="width:100%; padding-left: 5px; padding-top: 20px">
            <loading :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="fullPage"
                     :opacity=".85"
                     :before="true">
                <template v-slot:before><h3>Loading ...</h3></template>
            </loading>
            <b-tab v-for="value in editableSurvey.sections" :title="tabTitle('{{ key }}')" active
                   @click="tabClick( value.sectionName)" :key="value.sectionName">

                <template slot="title">
                    <div style="padding: 2px; font-size: 12px">
                        <font-awesome-icon icon="wine-bottle" size="1x"/>
                        {{ titleCase(value.sectionName.replace(/_/g," ")) }}
                    </div>
                </template>
                <b-row>
                    <b-col cols="9" class="text-left">
                        <div style="float: left">
                            <b-button v-b-toggle="`collapse-${value.sectionName}`" size="sm"
                                      class="bg-transparent chev-btn">
                                <span class="when-opened">
                                    <i class="fa fa-chevron-down fa-2x" aria-hidden="true" style="color: #1b1e21;"></i>
                                </span>
                                <span class="when-closed">
                                    <i class="fa fa-chevron-up fa-2x" aria-hidden="true" style="color: #1b1e21;"></i>
                                </span>
                            </b-button>
                        </div>
                        <h3>
                            <span style="color: green">Section:</span> {{ titleCase(value.sectionName.replace(/_/g," "))
                            }}
                        </h3>
                    </b-col>
                    <b-col cols="3">
                    </b-col>
                </b-row>
                <b-collapse style="margin-left: 30px; width: 90%" :id="getCollapseId(value.sectionName,null)">
                    <div v-for="page in value.checkListPages" :key="page.pageName">
                        <b-row>
                            <b-col cols="9" class="text-left">
                                <div style="float: left">
                                    <b-button v-b-toggle="`collapse-${page.pageName}`" size="sm"
                                              class="bg-transparent chev-btn">
                                <span class="when-opened">
                                    <i class="fa fa-chevron-down fa-2x" aria-hidden="true" style="color: #1b1e21;"></i>
                                </span>
                                        <span class="when-closed">
                                    <i class="fa fa-chevron-up fa-2x" aria-hidden="true" style="color: #1b1e21;"></i>
                                </span>
                                    </b-button>
                                </div>
                                <h2>
                                    <span style="color: green">Page:</span> {{page.pageName }}
                                </h2>
                            </b-col>
                            <b-col cols="3">
                            </b-col>
                        </b-row>
                        <b-collapse style="margin-left: 50px; width: 90%" :id="getCollapseId(page.pageName,null)">
                            <CheckListPage :page="page"/>
                        </b-collapse>
                    </div>

                </b-collapse>
            </b-tab>
            <QuestionEditorModal :value="modalOpen" :element="measureUpdate"
                                 :show="this.showModal"></QuestionEditorModal>
            <b-row style="margin: 10px 0 10px 0">
            </b-row>
        </b-tabs>
    </div>
</template>

<script>
import Bus from "../eventBus";
import QuestionEditorModal from "./QuestionEditorModal";
import Swal from "sweetalert2";
import CheckListPage from "./CheckListPage";
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "ChecklistSection",
  components: {
    CheckListPage,
    QuestionEditorModal,
    Loading
  },
  data() {
    return {
      isLoading: false,
      fullPage: false,
                modalOpen: false,
                showModal: true,
                measureUpdate: {},
                editableSurvey: {}
            }
        },
        mounted() {
            this.loadChecklist();
        },
        methods: {
            loadChecklist: function () {
                let self = this;
                self.isLoading = true;
                this.$http.get("survey/editable/active")
                    .then(result => {
                        self.survey = result.data;
                        self.editableSurvey = result.data;
                    })
                    .then(function () {
                        self.isLoading = false;
                    })
                    .catch(error => {
                        Swal.fire("Failed To Fetch Survey", `Could not Fetch survey: ${error.message}`, "error");
                    })
            },
            tabTitle(title) {
                return `${title}`;
            },
            capitalize: function (str) {
                if (str.length === 0) return str;
                return str[0].toUpperCase() + str.substr(1);
            },
            titleCase: function (str) {
                return str.split(' ').map(this.capitalize).join(' ');
            },
            getCollapseId(name, section) {
                let start = `collapse-${name}`;
                if (section) {
                    start = start + `-${section}`;
                }
                return start;
            },
            tabClick(tab) {
                switch (tab) {
                    case 'first':
                        console.log("first tab");
                        break;
                    case 'ENERGY':
                        console.error("energy tab");
                        console.error("current page: " + this.survey.currentPage);
                        this.survey.currentPage = "ENERGY";
                        break;

                    case 'WATER':
                        console.error("water tab");
                        console.error("current page: " + this.survey.currentPage);
                        this.survey.currentPage = "WATER";
                        break;
                    default:
                        console.error("current page: " + this.survey.currentPage);
                        this.survey.currentPage = tab.toUpperCase().replace(" ", "_");
                        break;
                }
            },
            saveUpdatedMeasure(measure) {
                this.saveMeasure(measure)
            },
            saveMeasure: function (measure) {
                this.$http.put(`/measures`, measure)
                    .then(response => {
                        if (response.status === 202) {
                            this.updateSurvey();
                        }
                    })
                    .catch(err => {
                        Swal.fire("Update Failed", `Update failed with error: ${err.message}`, "error");
                    });
            },
            submitNewMeasure(measure, pageName) {
                this.createMeasure(measure, pageName);
            },
            createMeasure: function (measure, pageName) {
                this.$http.post(`/measures`, measure)
                    .then(response => {
                        if (response.status === 202) {
                            let measureId = response.data;
                            this.updateMeasureId(measureId, pageName, measure.type, measure.name);
                            this.updateSurvey();
                        }
                    })
                    .catch(err => {
                        Swal.fire("Creation Failed", `Creation failed with error: ${err.message}`, "error");
                    });
            },
            updateMeasureId: function (measureId, pageName, type, name) {
                this.editableSurvey.sections.forEach(section => {
                    section.checkListPages.forEach(page => {
                        if (page.pageName === pageName) {
                            if (type === 'CORE') {
                                this.updateMeasureByName(page.coreQuestions, name, measureId);
                            } else {
                                this.updateMeasureByName(page.electiveQuestions, name, measureId);
                            }
                        }
                    })
                })
            },
            updateMeasureByName: function (questions, theName, measureId) {
                let index = questions
                    .map(quest => {
                        return quest.name;
                    })
                    .indexOf(theName);
                if (index !== -1) {
                    let measureToUpdate = questions[index]
                    measureToUpdate._id = measureId;
                }
            },
            updateSurvey: function () {
                let self = this;
                this.$http.put(`/survey/editable/${self.editableSurvey._id}`, self.editableSurvey)
                    .then(response => {
                        if (response.status === 202) {
                            this.$toasted.show("Survey Update Successful",
                                {
                                    containerClass: 'super-toasty',
                                    iconPack: 'fontawesome',
                                    closeOnSwipe: true,
                                    action: {
                                        text: 'DISMISS',
                                        onClick: (e, toastObject) => {
                                            toastObject.goAway(0);
                                        }
                                    },
                                    icon: {
                                        name: 'fa-check-circle',
                                        after: false,
                                    }
                                })
                                .goAway(5000);
                        }
                    })
                    .catch(err => {
                        this.$toasted.show(`Survey Update Failed: ${err.message}`,
                            {
                                containerClass: 'super-toasty',
                                iconPack: 'fontawesome',
                                closeOnSwipe: true,
                                action: {
                                    text: 'DISMISS',
                                    onClick: (e, toastObject) => {
                                        toastObject.goAway(0);
                                    }
                                },
                                icon: {
                                    name: 'fa-times-circle',
                                    after: false,
                                }
                            })
                            .goAway(5000);
                    });
            },
            updateSurveyExternal: function () {
                this.updateSurvey();
            }
        },
        created() {
            Bus.$on('edit-question', this.updateQnum);
            Bus.$on('question-modal', this.handleModalClose);
            Bus.$on('edit-measure', this.saveUpdatedMeasure);
            Bus.$on('create-measure', this.submitNewMeasure);
            Bus.$on('update-survey', this.updateSurveyExternal);
        },
        beforeDestroy() {
            Bus.$off('edit-question', this.updateQnum);
            Bus.$off('question-modal', this.handleModalClose);
            Bus.$off('edit-measure', this.saveUpdatedMeasure);
            Bus.$off('create-measure', this.submitNewMeasure);
            Bus.$off('update-survey', this.updateSurveyExternal);
        }
    }
</script>

